// extracted by mini-css-extract-plugin
export default {"days":"Days_days__pHcvV","tabs":"Days_tabs__Q4xP9","cancel":"Days_cancel__WB66U","tab":"Days_tab__FGIZf","tabs__wrapper":"Days_tabs__wrapper__ZrarS","link":"Days_link__Jcufw"};